"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  avatarImage: {
    objectFit: 'cover',
    borderRadius: '4%'
    // backgroundColor: theme.palette.custom.blackOpaque,
  },
  large: _objectSpread({
    height: theme.typography.pxToRem(250),
    width: theme.typography.pxToRem(250)
  }, theme.typography.h2),
  medium: _objectSpread({
    height: theme.typography.pxToRem(100),
    width: theme.typography.pxToRem(100)
  }, theme.typography.h3),
  small: _objectSpread({
    height: theme.typography.pxToRem(60),
    width: theme.typography.pxToRem(60)
  }, theme.typography.h5),
  'x-small': _objectSpread({
    height: theme.typography.pxToRem(50),
    width: theme.typography.pxToRem(50)
  }, theme.typography.h6)
}), {
  name: 'Avatar'
});
var _default = exports.default = useStyles;